<script>
	import Hextiles from "./tiles/Hextiles.svelte"

	export let w = 400
export let h = 600
export let divider = 10
export let tile = (w/divider)
	let hexw = tile
	let hexh = tile* 1.1547005
	let name = 'world';	
	//divide the space up equally


let rows = Math.ceil(h/tile)
let cols = Math.ceil(w/tile)

 
let fullw = tile*cols
let fullh = tile*rows

let xshift = fullw-hexw/2
let yshift = fullh-hexh/2
	
	    function hexPoints(x, y, radius) {
      var points = [];
      for (var theta = 0; theta < Math.PI * 2; theta += Math.PI / 3) {
        var pointX, pointY;

        pointX = x + radius * Math.sin(theta);
        pointY = y + radius * Math.cos(theta);

        points.push(pointX + ',' + pointY);
      }

      return points.join(' ');
    }
	
	function randomColor(){
		return ("rgba(0,0,0,"+Math.random()+")" );
	}
	
	
</script>


<svg viewBox="0 0 400 600" width = {w} height={h}  >
	

	<g>
	{#each Array(rows) as _, i}
		{#each Array(cols) as _, ii}


	{#if (i % 2 == 0)}

	<g transform="translate({(tile*ii)-(xshift/2)} {(tile*i)-(yshift/2)})">	
		<Hextiles/>
	</g>
	

	{:else}
	<polygon points="{hexPoints(((hexw*ii)-hexw/2)*2,(hexh+hexh/2)*i,hexh)}" 
		fill="{randomColor()}"
        stroke="white"
        stroke-width="8"
	/>

	{/if}	
	{/each}
	{/each}
		

	</g>
</svg>
